var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#008000",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M0.6 1019.86 C0.6 1002.22 14.9 987.89 32.51 987.89 C50.11 987.89 64.41 1002.22 64.41 1019.86 C64.41 1037.49 50.11 1051.82 32.51 1051.82 C14.9 1051.82 0.6 1037.49 0.6 1019.86 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M18.36 1019.53 C18.36 1011.89 24.46 1005.69 31.96 1005.69 C39.46 1005.69 45.55 1011.89 45.55 1019.53 C45.55 1027.16 39.46 1033.37 31.96 1033.37 C24.46 1033.37 18.36 1027.16 18.36 1019.53 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.007507 0 0 0.992549 23.710783 1005.641601)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.38
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.64
  }, "6"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6B);
export default __webpack_public_path__ + "static/media/6B.89c6a5bdb6616bbb10c0ba8fde91c33c.svg";
export { ForwardRef as ReactComponent };